import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      border: 'solid 1px #009ACE',
      borderWidth: '2px',
      borderRadius: '5px',
      padding: '12px 4px',
      minHeight: '1em',
      width: '85%',
      margin: 'auto',
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      ['@media (max-width: 768px)']: {
        fontSize: '9px',
        padding: '8px 4px',
        minHeight: 6,
        borderWidth: '1px',
      },
      ['@media (max-width: 340px)']: {
        fontSize: '6px',
        maxHeight: 4,
        borderWidth: '1px',
        padding: '4px 4px',
      },
    },
    oldRoot: {
      background: 'white',
      borderRadius: '1px',
      border: 'none',
      width: '90%',
    },
    header: {
      position: 'absolute',
      marginTop: '-1.5rem',
      color: '#009ACE',
      background: 'white',
      borderRadius: '10px',
      padding: '2px 2px',
      ['@media (max-width: 768px)']: {
        fontSize: '0.5rem',
        marginTop: '-1.8em',
      },
      ['@media (max-width: 340px)']: {
        fontSize: '6px',
      },
    },
  },
  {
    name: 'MockAuth0TextField',
  },
);
